import React, { useState } from "react"
import PhoneInput from "react-phone-number-input"

import "react-phone-number-input/style.css"
import { Input, Label } from "./Inputs"

type InternationalPhoneInputProps = {
  inputId?: string
  name?: string
  value?: string
  disabled?: boolean
  className?: string
  label?: string
  labelClassName?: string
  required?: boolean
  onChange?: (value: string) => void
}

const InternationalPhoneInput = ({
  inputId,
  name,
  value,
  disabled = false,
  className,
  label,
  labelClassName,
  required = false,
  onChange
}: InternationalPhoneInputProps) => {
  const [uncontrolledValue, setUncontrolledValue] = useState(value || "")
  // Rails react_component passes `value` + `name` without onChange (form hidden input).
  // React callers pass both `value` and `onChange`.
  const isControlled = value !== undefined && typeof onChange === "function"
  const phone = isControlled ? value || "" : uncontrolledValue

  const handleChange = (nextValue: string | undefined) => {
    const normalized = nextValue || ""
    if (!isControlled) setUncontrolledValue(normalized)
    onChange?.(normalized)
  }

  return (
    <div className={className}>
      {label ? (
        <Label className={labelClassName} htmlFor={inputId}>
          {label} {required ? <span className="text-red">*</span> : null}
        </Label>
      ) : null}
      <PhoneInput
        id={inputId}
        international
        country="US"
        defaultCountry="US"
        value={phone || undefined}
        onChange={handleChange}
        inputComponent={Input}
        disabled={disabled}
      />
      {name ? <input type="hidden" name={name} value={phone} /> : null}
    </div>
  )
}

export default InternationalPhoneInput
